"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.voucherStatus = void 0;
var React = require("react");
var moment = require("moment");
var mobx_react_1 = require("mobx-react");
var lang_1 = require("../../../../utils/lang");
var voucherStore_1 = require("./voucherStore");
var MiniTip_1 = require("mobile/components/MiniTip");
var Dialog_1 = require("mobile/components/Dialog");
var ModalClose_1 = require("mobile/components/ModalClose");
var link_1 = require("mobile/utils/link");
var css_1 = require("mobile/utils/css");
var array_1 = require("utils/array");
var ss = require("./index.scss");
var getLang = lang_1.getEzbuyLang();
exports.voucherStatus = function (voucherData, link) {
    var voucherState = voucherData.voucherState;
    switch (voucherState) {
        case voucherStore_1.VoucherState.ComingSoon:
            return getLang("COMING SOON");
        case voucherStore_1.VoucherState.FullyRedeemed:
            return getLang("FULLY REDEEMED");
        case voucherStore_1.VoucherState.Expired:
            return getLang("EXPIRED");
        case voucherStore_1.VoucherState.GrabNow:
            return getLang("GRAB NOW");
        case voucherStore_1.VoucherState.Redeemed:
            if (link) {
                return getLang("GO SHOPPING");
            }
            else {
                return getLang("REDEEMED");
            }
    }
};
var Voucher = (function (_super) {
    __extends(Voucher, _super);
    function Voucher(props) {
        var _this = _super.call(this, props) || this;
        _this.store = new voucherStore_1.VoucherStore();
        _this.getVoucherType = function (columnNum) {
            switch (columnNum) {
                case 1:
                case 2:
                case 3:
                    return VoucherModule;
                default:
                    return null;
            }
        };
        _this.closeModal = function () {
            _this.setState({ isShow: false });
        };
        _this.getVoucherCom = function (columnNum) {
            var _a = _this.props, moduleDetail = _a.moduleDetail, overAllBgc = _a.overAllBgc;
            var module = moduleDetail.module;
            var vouchers;
            var VoucherCard = _this.getVoucherType(columnNum);
            var voucherDataArr = _this.store.voucherDataArr;
            if (module.vouchers && module.vouchers.length > 0) {
                vouchers = module.vouchers;
            }
            var voucherData = voucherDataArr.map(function (ele, i) {
                return VoucherCard && (React.createElement(VoucherCard, { key: i, voucherData: ele, voucherInfo: vouchers[i], overAllBgc: overAllBgc, store: _this.store, type: columnNum, getDetail: function (link, img, startDate, endDate) {
                        _this.setState({
                            link: link,
                            img: img,
                            startDate: startDate,
                            endDate: endDate,
                            isShow: true
                        });
                    } }));
            });
            return voucherData;
        };
        _this.getDialog = function () {
            var _a = _this.state, link = _a.link, img = _a.img, startDate = _a.startDate, endDate = _a.endDate, isShow = _a.isShow;
            return (React.createElement(Dialog_1.default, { show: isShow, isAutoFixedBody: true },
                React.createElement(ModalClose_1.default, { onClose: _this.closeModal },
                    React.createElement("div", { className: ss.receemedModal },
                        React.createElement("div", { className: ss.congratulation },
                            getLang("Congratulation! You have got"),
                            React.createElement("img", { src: img })),
                        React.createElement("div", { className: ss.expiredTime },
                            getLang("Expired Date"),
                            ": ",
                            moment.unix(startDate).format("DD/MM/YYYY"),
                            " -",
                            " ",
                            moment.unix(endDate).format("DD/MM/YYYY")),
                        React.createElement("div", { className: ss.useVoucher }, getLang("Use this voucher upon check out to enjoy great discounts!")),
                        link && (React.createElement("div", { className: ss.btn, onClick: function () {
                                _this.closeModal();
                                link_1.clickJump(link);
                            } }, getLang("GO SHOPPING")))))));
        };
        _this.getHeight = function (columnNum) {
            var module = _this.props.moduleDetail.module;
            switch (columnNum) {
                case 1:
                    return 6.93 * (module.vouchers && module.vouchers.length) + 0.75 + "rem";
                case 2:
                    return css_1.px2rem(111);
                case 3:
                    return css_1.px2rem(98);
                default:
                    return "initial";
            }
        };
        _this.state = {
            link: "",
            img: "",
            startDate: null,
            endDate: null,
            isShow: false
        };
        return _this;
    }
    Voucher.prototype.componentDidMount = function () {
        var module = this.props.moduleDetail.module;
        if (module && module.vouchers && module.vouchers.length > 0) {
            var voucherIds_1 = [];
            module.vouchers.forEach(function (ele) { return voucherIds_1.push(ele.voucherId); });
            this.store.getVoucherData(voucherIds_1);
        }
    };
    Voucher.prototype.render = function () {
        var _a = this.props, moduleDetail = _a.moduleDetail, overAllBgc = _a.overAllBgc, commonProps = _a.commonProps, index = _a.index, addModuleMap = _a.addModuleMap;
        var layout = moduleDetail.layout;
        var styles = { backgroundColor: overAllBgc };
        var columnNum;
        if (layout && layout.columnNum) {
            columnNum = layout.columnNum;
        }
        var voucherClassName = columnNum === 1 ? "One" : "Two";
        var hasValidData = array_1.isNotBlankArray(this.store.voucherDataArr);
        if (!hasValidData) {
            return null;
        }
        return (React.createElement("div", { style: { minHeight: this.getHeight(columnNum) } },
            this.getDialog(),
            [1, 2].includes(columnNum) && (React.createElement("div", { className: ss["voucherWrap" + voucherClassName], style: styles, ref: function (node) {
                    if (node) {
                        addModuleMap(index, node, "#" + commonProps.id);
                    }
                } }, this.getVoucherCom(columnNum))),
            columnNum === 3 && (React.createElement("div", { className: ss.voucherWrapThree, ref: function (node) {
                    if (node) {
                        addModuleMap(index, node, "#" + commonProps.id);
                    }
                }, style: styles },
                React.createElement("div", { className: ss.box }, this.getVoucherCom(columnNum))))));
    };
    Voucher = __decorate([
        mobx_react_1.observer
    ], Voucher);
    return Voucher;
}(React.Component));
exports.default = Voucher;
var VoucherModule = (function (_super) {
    __extends(VoucherModule, _super);
    function VoucherModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.claimDown = function (voucherState, link, img, startDate, endDate, remainCount) { return __awaiter(_this, void 0, void 0, function () {
            var voucherInfo, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        voucherInfo = this.props.voucherInfo;
                        _a = voucherState;
                        switch (_a) {
                            case voucherStore_1.VoucherState.ComingSoon: return [3, 1];
                            case voucherStore_1.VoucherState.Expired: return [3, 2];
                            case voucherStore_1.VoucherState.FullyRedeemed: return [3, 3];
                            case voucherStore_1.VoucherState.Redeemed: return [3, 4];
                            case voucherStore_1.VoucherState.GrabNow: return [3, 5];
                        }
                        return [3, 7];
                    case 1:
                        MiniTip_1.default(getLang("Voucher coming soon"), 800);
                        return [3, 7];
                    case 2:
                        MiniTip_1.default(getLang("Voucher has expired"), 800);
                        return [3, 7];
                    case 3:
                        MiniTip_1.default(getLang("Voucher has been Fully Redeemed"), 800);
                        return [3, 7];
                    case 4:
                        if (link) {
                            link_1.clickJump(link);
                            return [3, 7];
                        }
                        else {
                            if (remainCount <= 0) {
                                MiniTip_1.default(getLang("Voucher has been Fully Redeemed"), 800);
                                return [3, 7];
                            }
                            else {
                                MiniTip_1.default(getLang("You have reached the voucher redemption limit"), 800);
                                return [3, 7];
                            }
                        }
                        _b.label = 5;
                    case 5: return [4, this.props.store.receiveVoucher(voucherInfo.voucherId)];
                    case 6:
                        if (_b.sent()) {
                            this.props.getDetail(link, img, startDate, endDate);
                        }
                        return [3, 7];
                    case 7: return [2];
                }
            });
        }); };
        return _this;
    }
    VoucherModule.prototype.render = function () {
        var _this = this;
        var _a = this.props, voucherData = _a.voucherData, voucherInfo = _a.voucherInfo, overAllBgc = _a.overAllBgc, type = _a.type;
        var voucherState = voucherData.voucherState, startDate = voucherData.startDate, endDate = voucherData.endDate, remainCount = voucherData.remainCount;
        var textBgColor = "#FF3B30", textColor = "#fff", img = "", link;
        var info = voucherInfo.info, ui = voucherInfo.ui;
        if (ui && ui.bgColor) {
            textBgColor = ui.bgColor;
            if (ui.colorTable && ui.colorTable.textColor) {
                textColor = ui.colorTable.textColor;
            }
        }
        if (info && info.img) {
            img = info.img;
        }
        if (info && info.link) {
            link = info.link;
        }
        var isFinishOrFullyReceem = voucherState === voucherStore_1.VoucherState.FullyRedeemed || voucherState === voucherStore_1.VoucherState.Expired;
        var voucherModuleClassName = type === 1 ? "One" : type === 2 ? "Two" : "Three";
        var textComponent = (React.createElement("div", { className: ss.text, style: isFinishOrFullyReceem
                ? { backgroundColor: "#ddd", color: "#6E6E6E" }
                : { backgroundColor: textBgColor, color: textColor }, onClick: function () { return _this.claimDown(voucherState, link, img, startDate, endDate, remainCount); } },
            React.createElement("a", null, exports.voucherStatus(voucherData, link))));
        var voucherImgComponent = (React.createElement("img", { src: img, className: ss.img, style: isFinishOrFullyReceem ? { filter: "grayscale(100%)", opacity: 0.4 } : {} }));
        var redeemedStampImgComponent = (React.createElement("img", { className: ss.redeemedStampImg, src: getLang("REDEEMEDSTAMP"), onClick: function () { return _this.claimDown(voucherState, link, img, startDate, endDate, remainCount); } }));
        var singleVoucherComponent = (React.createElement("div", { className: ss.item },
            voucherImgComponent,
            textComponent,
            voucherState === voucherStore_1.VoucherState.Redeemed && redeemedStampImgComponent));
        var multiVoucherComponent = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: ss.imgWrap }, voucherImgComponent),
            textComponent,
            voucherState === voucherStore_1.VoucherState.Redeemed && redeemedStampImgComponent));
        return (React.createElement("div", { className: ss["voucherModuleWrap" + voucherModuleClassName] },
            type === 1 ? singleVoucherComponent : multiVoucherComponent,
            React.createElement("i", { className: ss.leftCircle, style: { backgroundColor: overAllBgc } }),
            React.createElement("i", { className: ss.rightCircle, style: { backgroundColor: overAllBgc } })));
    };
    return VoucherModule;
}(React.Component));
